<template>
  <div class="">
    <h2 class="white">Selecione o Convênio</h2>
    <div v-if="error_message" class="error-panel">{{ error_message }}</div>
    <div class="ui five column grid">
      <div v-for="agreement in agreements" :key="agreement.id" class="column" style="display: flex;">
        <div v-show="agreement.image != null" class="option" @click="selectAgreement(agreement.id)">
          <img :src="$baseUrl + '/storage/' + agreement.image" alt="">
        </div>
        <div v-show="agreement.image == null" class="option" style="width: 220px;">
          <span>{{ agreement.name }}</span>
        </div>
      </div>
    </div>
    <div class="footer-btn">
      <div id="back-btn" class="btn btn-cancel" @click.prevent="$emit('backClicked', 'StartPage');">
        <i class="ui sign-out icon"></i>
        <span>Cancelar</span>
      </div>
    </div>
  </div>
</template>
<script>
import moment from 'moment';
export default {
  props: {
    agreements: Array,
    customer: Object,
    ticket: Object
  },
  data() {
    return {
      loading: false,
      msg: 'Por favor, escolha um convênio.',
      error_message: ''
    }
  },
  mounted() {
    this.speak(this.msg);
  },
  methods: {
    speak(msg) {
      var utterThis = new SpeechSynthesisUtterance(msg);
      var voices = speechSynthesis.getVoices();
      var voice_br = {};
      voices.map((value, i) => {
        if (value.lang == 'pt-BR') {
        }
      });
      window.speechSynthesis.speak(utterThis);
    },
    selectAgreement(id) {
      if (!this.loading) {
        this.loading = true;
        this.error_message = '';
        var app = this;
        this.$emit('setAgreement', id);
        if (this.ticket.attendance_type_id == 1) {
          setTimeout(function () {
            app.$emit('buttonClicked', 'ProfsList');
          }, 300);
        } else if (this.ticket.attendance_type_id == 2) {
          if (this.customer.id == 0) {
            console.log('novo cliente');
            const axiosHeaders = {
              headers: {
                'Content-Type': 'multipart/form-data'
              }
            };
            var byteString;
            var photo = this.ticket.photo;
            if (photo.split(',')[0].indexOf('base64') >= 0)
              byteString = atob(photo.split(',')[1]);
            else
              byteString = unescape(photo.split(',')[1]);
            // separate out the mime component
            var mimeString = photo.split(',')[0].split(':')[1].split(';')[0];
            // write the bytes of the string to a typed array
            var ia = new Uint8Array(byteString.length);
            for (var i = 0; i < byteString.length; i++) {
              ia[i] = byteString.charCodeAt(i);
            };

            var blob = new Blob([ia], { type: mimeString });

            var formDataCustomer = new FormData();
            formDataCustomer.append('image', blob);
            formDataCustomer.set('name', this.customer.name);
            formDataCustomer.set('agreement_id', id);
            formDataCustomer.set('second_id', 0);
            axios.post('api/kiosk/customer', formDataCustomer, axiosHeaders)
              .then(({ data }) => {
                console.log('cliente gravado');
                // Setando ticket
                var ticketObj = this.ticket;
                ticketObj.customer_id = data.data.id;
                ticketObj.name = data.data.name;
                ticketObj.photo = data.data.image;
                ticketObj.agreement_id = id;
                ticketObj.professional_id = null;
                ticketObj.started_at = moment().format('Y-MM-DD HH:mm:ss');
                // Gravando ticket
                axios.post('api/kiosk/ticket', ticketObj)
                  .then(({ data }) => {
                    console.log('ticket gravado');
                    this.loading = false

                    this.$emit('buttonClicked', 'FinishTicket');
                  }).catch((err) => {
                    this.loading = false
                    this.error_message = 'Não foi possível gerar o atendimento. Tente novamente.';
                  });
              }).catch((err) => {
                this.loading = false
                this.error_message = 'Não foi possível cadastrar o paciente. Tente novamente.';
              });
          } else {
            console.log('exame - cliente selecionado');
            // Setando ticket
            var ticketObj = this.ticket;
            ticketObj.customer_id = this.customer.id;
            ticketObj.name = this.customer.name;
            ticketObj.photo = this.customer.image;
            ticketObj.agreement_id = id;
            ticketObj.professional_id = null;
            ticketObj.started_at = moment().format('Y-MM-DD HH:mm:ss');
            // Gravando ticket
            axios.post('api/kiosk/ticket', ticketObj)
              .then(({ data }) => {
                this.loading = false
                console.log('ticket gravado');
                this.$emit('buttonClicked', 'FinishTicket');
              }).catch((err) => {
                this.loading = false
                this.error_message = 'Não foi possível gerar o atendimento. Tente novamente.';
              });

          }

        }
      }
    },

  }
}
</script>
<style scoped>
h2 {
  text-align: center;
  font-size: 42px;
  font-weight: bold;
  font-family: 'Source Sans Light';
}

.option {
  /* height: 206px; */
  height: 140px;
  margin: 0 auto;
  padding-top: 10px;
  background: #56ccf2;
  border-radius: 20px;
  box-shadow: 0px 10px 8px rgba(0, 0, 0, 0.22), 0 1px 2px rgba(0, 0, 0, 0.23);
  cursor: pointer;
}

.option img {
  /* width: 180px;
  height: 180px; */
  width: 120px;
  height: 120px;
  margin: 0 20px;
  background: #fff;
  border-radius: 500px;
}

.option span {
  position: absolute;
  bottom: 100px;
  left: 50px;
  width: 200px;
  font-size: 20px;
  color: #fff;
  line-height: 33px;
  border: 1px solid;
}

/* .footer-btn {
  position: fixed;
  bottom: 16px;
  padding: 0px 20px;
}
.btn {
  display: flex;
  width: 180px;
  height: 60px;
  align-items: center;
  font-size: 26px;
  border-radius: 500px;
  background-color: rgb(255, 255, 255);
  box-shadow: 0 3px 6px rgba(0, 0, 0, 0.16), 0 1px 2px rgba(0, 0, 0, 0.23);
  cursor: pointer;
}
.btn span {
  width: inherit;
} */</style>



// WEBPACK FOOTER //
// src/components/AgreementsList.vue